import React, {Component}                                       from "react";
import {Image, ImageBackground, Text, TouchableOpacity, View}   from "react-native";
import NBButton                                                 from "./NBButton";
import styles                                                   from "../styles/Styles";

export default class Player extends Component {
    render() {
        var accuracy;
        if (this.props.swipeControls) {
            accuracy = "--------------";
        }
        else {
            accuracy = "Accuracy: " + ((this.props.guesses > 0) ? Math.floor(100 * this.props.numCorrect / this.props.guesses) : "---") + "%";
        }

        var button = null;
        var icon = null;
        if (this.props.icon != null || this.props.swipeControls) {
            var iconStyle = (this.props.selected || this.props.swipeControls) ? styles.playerIconSelected : styles.playerIcon;
            var onPress = this.props.swipeControls ? null : this.props.selectPlayer;
            icon =  <TouchableOpacity onPress={onPress}>
                        <Image source={{uri: "data:image/png;base64," + this.props.icon}} style={iconStyle} />
                    </TouchableOpacity>;
        }
        else if (!this.props.selected) {
            button = <NBButton onPress={this.props.selectPlayer} text="Select" />
        }

        return (
            <View style={styles.viewPlayer}>
                <ImageBackground source={require("../../assets/player.png")} style={styles.background} imageStyle={styles.backgroundImageStretch} >
                    <View style={styles.player}>
                        {icon}
                        <Text>{this.props.name}</Text>
                        <Text>Score: {this.props.score}</Text>
                        <Text>{accuracy}</Text>
                        {!this.props.swipeControls && button}
                    </View>
                </ImageBackground>
            </View>
        );
    }
}